import { render, staticRenderFns } from "./StyleStudyRanking.vue?vue&type=template&id=71945507&scoped=true&"
import script from "./StyleStudyRanking.vue?vue&type=script&lang=js&"
export * from "./StyleStudyRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71945507",
  null
  
)

export default component.exports